import { render, staticRenderFns } from "./infoobs.vue?vue&type=template&id=17400af4&scoped=true&"
import script from "./infoobs.vue?vue&type=script&lang=js&"
export * from "./infoobs.vue?vue&type=script&lang=js&"
import style0 from "./infoobs.vue?vue&type=style&index=0&id=17400af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17400af4",
  null
  
)

export default component.exports